import SearchIcon from '@mui/icons-material/Search';
import { styled, InputBase } from '@mui/material';

import theme from 'core/ThemeConstants';

const StyledSearchInput = styled(InputBase)(() => ({
  height: 40,
  fontSize: 12,
  maxWidth: 450,
  width: '100%',
  fontWeight: 600,
  padding: '0.5rem',
  borderRadius: '4px',
  backgroundColor: theme.white.default,
  color: theme.black.default,
  border: `1px solid ${theme.black.default}`,
}));

const StyledSearchIcon = styled(SearchIcon)(() => ({
  fontSize: 16,
  marginLeft: '0.5rem',
  marginRight: '0.5rem',
  color: theme.black.default,
}));

export { StyledSearchInput, StyledSearchIcon };
